import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-confidence-badge',
  templateUrl: './confidence-badge.component.html',
  styleUrls: ['./confidence-badge.component.scss'],
})
export class ConfidenceBadgeComponent implements OnInit {
  @Input() confidence: number;

  constructor() {}

  ngOnInit() {}
}
